require('./brokerOrdersAndMovementsConsult.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const InformativeItem = require('components/commons/informativeItem/informativeItem');
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const { formatAmountObject, formatAmount } = require('utilities/currencyHelper');
const { toFirstUppercase, capitalize } = require('utilities/stringHelper');
const DateHelper = require('utilities/dateHelper');
// @ constants
const {
    BROKER_JOINT_CONTRACTS_CRYPTO,
    BROKER_JOINT_CONTRACTS_VALUE,
    BROKER_JOINT_CONTRACTS_FUND,
    BROKER_JOINT_CONTRACTS_PLAN,
    BROKER_JOINT_CONTRACTS_FUTURES,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC,
    BROKER_STOCKS_CONTRACT_DROPDOWN_GROUPED_CONTRACTS_MODIFIER,
    DATE_FORMAT_ES,
    HYPHEN,
    TYPE_STOCKS,
    TYPE_FUNDS,
    TYPE_PLANS,
    TYPE_ETFS,
    TYPE_WARRANTS,
    TYPE_FUTURES,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES
} = require('constants/index');
const mockDataHelper = require('../../../routes/contractsView/utilities/mockDataHelper');

class BrokerOrdersAndMovementsConsult extends React.Component {
    constructor(props) {
        super(props);

        this.handleStockContractChange = this.handleStockContractChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
    }

    componentDidMount() {
        this.setDefaultSelectedContract();
    }

    getContractIdByNumber(contractNumber) {
        const contract = this.props.immJointContracts.get('byId').find(contract => {
            return contract.get('walletNumber').endsWith(contractNumber);
        });

        return contract ? contract.get('id') : '';
    }

    getUniqueProductContractId(type) {
        let contractId;
        switch (type) {
            case TYPE_STOCKS:
            case TYPE_ETFS:
            case TYPE_WARRANTS:
                contractId = this.findContractId(BROKER_JOINT_CONTRACTS_VALUE);
                break;
            case TYPE_FUNDS:
                contractId = this.findContractId(BROKER_JOINT_CONTRACTS_FUND);
                break;
            case TYPE_PLANS:
                contractId = this.findContractId(BROKER_JOINT_CONTRACTS_PLAN);
                break;
            case TYPE_FUTURES:
                contractId = this.findContractId(BROKER_JOINT_CONTRACTS_FUTURES);
                break;
            default:
                contractId = '';
        }

        return contractId;
    }

    setDefaultSelectedContract() {
        const { immOrdersAndMovements, immJointContracts, planId } = this.props;
        const selectedContract = planId ? planId : immOrdersAndMovements.get('selectedContract');
        let contractId;

        if (immJointContracts.get('byId').size === 1) {
            contractId = immJointContracts.get('byId').first().get('id');
        } else if (selectedContract) {
            contractId = this.getContractIdByNumber(selectedContract);
        } else {
            contractId = this.getUniqueProductContractId(immOrdersAndMovements.get('accessFrom'));
        }

        this.handleStockContractChange(contractId);
    }

    buildContractInformation() {
        const { immContract } = this.props;
        const intervenorType = toFirstUppercase(formatText(`interventionTypes-${capitalize(immContract.get('firstTitularType').trim())}`));
        let content;
        let associatedAccountContent;

        if (immContract.get('type') === BROKER_JOINT_CONTRACTS_VALUE || immContract.get('type') === BROKER_JOINT_CONTRACTS_CRYPTO) {
            const { amount, currencySymbol } = formatAmountObject(
                immContract.getIn(['associatedAccount', 'balance'], 0)
            );
            const balance = formatText('broker-ordersAndMovementsContractInformationAmount', [
                amount,
                currencySymbol
            ]);
            const intervenor = formatText(
                'broker-ordersAndMovementsContractInformationInterventionType',
                [intervenorType]
            );

            if (immContract.getIn(['associatedAccount', 'number'])) {
                associatedAccountContent = (
                    <InformativeItem
                        title={formatText(
                            'broker-ordersAndMovementsContractInformationAccount'
                        ).toUpperCase()}
                        primaryText={immContract.getIn(['associatedAccount', 'number'])}
                        secondaryText={balance}
                    />);
            } else {
                associatedAccountContent =  (
                    <InformativeItem
                        title={formatText('broker-ordersAndMovementsContractInformationAccount').toUpperCase()}
                        primaryText={HYPHEN}
                    />
                );
            }
            content = (
                <div className="row no-gutter">
                    <div className="col-xs-5">
                        {associatedAccountContent}
                    </div>
                    <div className="col-xs-7">
                        <InformativeItem
                            title={formatText(
                                'broker-ordersAndMovementsContractInformationTitular'
                            ).toUpperCase()}
                            primaryText={immContract.get('firstTitular')}
                            secondaryText={intervenor}
                        />
                    </div>
                </div>
            );
        } else {
            const assetValue = formatAmountObject(immContract.get('assetValue'));
            const dateLabel = DateHelper.buildFormattedDate(
                immContract.get('lastSettlementDate'),
                DATE_FORMAT_ES
            );
            const amount = `${formatAmount(assetValue.amount, undefined, 3) ||
                HYPHEN} ${assetValue.currencySymbol} (${dateLabel})`;

            content = (
                <div className="row">
                    <div className="col-xs-3 broker-orders-and-movements-consult__column">
                        <InformativeItem
                            title={formatText(
                                'broker-ordersAndMovementsContractInformationAccount'
                            ).toUpperCase()}
                            primaryText={immContract.getIn(['associatedAccount', 'number'])}
                        />
                    </div>
                    <div className="col-xs-3 broker-orders-and-movements-consult__mid-column-right">
                        <InformativeItem
                            title={formatText(
                                'broker-ordersAndMovementsContractInformationTitular'
                            ).toUpperCase()}
                            primaryText={immContract.get('firstTitular')}
                        />
                    </div>
                    <div className="col-xs-3 broker-orders-and-movements-consult__mid-column">
                        <InformativeItem
                            title={formatText(
                                'broker-ordersAndMovementsContractInformationShares'
                            ).toUpperCase()}
                            primaryText={formatAmount(
                                immContract.get('shares'),
                                undefined,
                                5
                            )}
                        />
                    </div>
                    <div className="col-xs-3 broker-orders-and-movements-consult__column">
                        <InformativeItem
                            title={formatText(
                                'broker-ordersAndMovementsContractInformationLastValue'
                            ).toUpperCase()}
                            primaryText={amount}
                        />
                    </div>
                </div>
            );
        }

        return (
            <section>
                <div className="broker-orders-and-movements-consult__separator" />
                <section className="broker-orders-and-movements-consult__contract-info">
                    {content}
                </section>
            </section>
        );
    }

    buildStocksContractDropdownOptions() {
        const { immJointContracts } = this.props;
        // TODO: once we integrate with the API we should update the following map statement.
        // In this map statement we should format the information comming from the backend to
        // the final structure needed by the stocks Contract dropdown.
        const contracts = immJointContracts.get('byId').map(
            entry => entry.merge({ value: entry.get('id') })
        ).toList().toJS();
        
        // Group contracts and add section titles
        const groupedContracts = contracts.reduce((group, contract) => {
            group[contract.type] = group[contract.type] || [];
            group[contract.type].push(contract);
            
            return group;
        }, {});

        const buildOptions = (type, label) => {
            const options = [];
            if (groupedContracts[type] && groupedContracts[type].length !== 0) {
                options.push(...groupedContracts[type]);
                options.sort(
                    (firstOption, secondOption) =>
                        secondOption.walletBalance.amount -
                        firstOption.walletBalance.amount
                );
                options.unshift({ disabled: true, label });
            }

            return options;
        }

        // This dictates the groups' order, first values, then funds, then plans and futures.
        const options = [
            ...buildOptions(BROKER_JOINT_CONTRACTS_VALUE, 'broker-ordersAndMovementsConsultLabelValue'),
            ...buildOptions(BROKER_JOINT_CONTRACTS_FUND, 'broker-ordersAndMovementsConsultLabelFund'),
            ...buildOptions(BROKER_JOINT_CONTRACTS_PLAN, 'broker-ordersAndMovementsConsultLabelPlan'),
            ...buildOptions(BROKER_JOINT_CONTRACTS_FUTURES, 'broker-ordersAndMovementsConsultLabelFuture'),
            ...buildOptions(BROKER_JOINT_CONTRACTS_CRYPTO, 'broker-ordersAndMovementsConsultLabelFuture'),
        ];

        return options;
    }

    findContractId(productType) {
        const contracts = this.props.immJointContracts.get('byId').filter(contract => {
            return contract.get('type') === productType;
        });

        return contracts.size === 1 ? contracts.first().get('id') : '';
    }

    handleOptionChange(selectedOption) {
        this.props.setSelectedOption(selectedOption);
    }

    handleStockContractChange(contractId) {
        this.props.setSelectedOption(null);
        this.props.setSelectedContract(contractId);
    }

    render() {
        const { selectedContract, immContract, selectedOption, immJointContracts, immFeatureFlag } = this.props;
        const ffContribution = immFeatureFlag.get('wealth_funds_periodic_contributions');
        const title = formatText('broker-ordersAndMovementsConsultTitle');
        const stocksContractDropdownOptions = this.buildStocksContractDropdownOptions();
        const stocksContractPlaceholder = formatText('broker-ordersAndMovementsConsultPlaceholder');
        const isUniqueContract = immJointContracts.get('byId').size === 1;
        let selector, contractInfo;

        if (immContract) {
            if (immContract.get('type') !== BROKER_JOINT_CONTRACTS_FUTURES) {
                //@Hardcoded: we need definitions for futures, do not show info in the meantime.
                contractInfo = this.buildContractInformation();
            }

            if (immContract.get('type') === BROKER_JOINT_CONTRACTS_FUND && !ffContribution) {
                const options = [
                    {
                        label: formatText('broker-ordersAndMovementsConsultSelectOptionPending'),
                        value: BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING
                    },
                    {
                        label: formatText(
                            'broker-ordersAndMovementsConsultSelectOptionConsolidated'
                        ),
                        value: BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED
                    },
                    {
                        label: formatText('broker-ordersAndMovementsConsultSelectOptionCancelled'),
                        value: BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED
                    }
                ];
                const label = formatText('broker-ordersAndMovementsConsultSelectState');

                selector = (
                    <div className="broker-orders-and-movements-consult__state-selector">
                        <OKSelect
                            name="broker-orders-and-movements-consult-state"
                            onChange={this.handleOptionChange}
                            value={selectedOption}
                            label={label}
                            options={options}
                            searchable={false}
                            clearable={false}
                        />
                    </div>
                );
            } else if (immContract.get('type') === BROKER_JOINT_CONTRACTS_PLAN) {
                const options = [
                    {
                        label: formatText('broker-ordersAndMovementsConsultSelectOptionPeriodic'),
                        value: BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC
                    },
                    /*{
                        label: formatText('broker-ordersAndMovementsConsultSelectOptionExtraordinary'),
                        value: BROKER_ORDERS_AND_MOVEMENTS_PLAN_EXTRAORDINARY
                    },*/
                    {
                        label: formatText('broker-ordersAndMovementsConsultSelectOptionOther'),
                        value: BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER
                    },
                    {
                        label: formatText('broker-ordersAndMovementsConsultSelectOptionPendingMoves'),
                        value: BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES
                    }
                ];
                const label = formatText('broker-ordersAndMovementsConsultSelectOperationType');

                selector = (
                    <div className="broker-orders-and-movements-consult__operation-type-selector">
                        <OKSelect
                            name="broker-orders-and-movements-consult-operation-type"
                            onChange={this.handleOptionChange}
                            value={selectedOption}
                            label={label}
                            options={options}
                            searchable={false}
                            clearable={false}
                        />
                    </div>
                );
            }
        }

        return (
            <OKSectionBox title={title} className="broker-orders-and-movements-consult">
                <div className="row">
                    <div className="col-xs-8">
                        <StocksContractDropdown
                            label="broker-ordersAndMovementsConsultLabel"
                            onStockContractChange={this.handleStockContractChange}
                            options={stocksContractDropdownOptions}
                            selectedValue={selectedContract}
                            placeholder={stocksContractPlaceholder}
                            showAdditionalInfo={false}
                            modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_GROUPED_CONTRACTS_MODIFIER}
                            disabled={isUniqueContract}
                            startResultsScrollAtTop={true}
                        />
                    </div>
                    <div className="col-xs-4">
                        {selector}
                    </div>
                </div>
                {contractInfo}
            </OKSectionBox>
        );
    }
}

BrokerOrdersAndMovementsConsult.propTypes = {
    immJointContracts: PropTypes.object.isRequired,
    selectedContract: PropTypes.string,
    selectedOption: PropTypes.object,
    immContract: PropTypes.object,
    immOrdersAndMovements: PropTypes.object,
    setSelectedContract: PropTypes.func.isRequired,
    setSelectedOption: PropTypes.func.isRequired,
    planId: PropTypes.string,
    immFeatureFlag: PropTypes.func.isRequired,
};

module.exports = BrokerOrdersAndMovementsConsult;
